import { Spacing12, Spacing24 } from 'autogen/design-tokens/tokens';
import { DonationOption } from 'autogen/swagger/all';
import React from 'react';
import styled from 'styled-components';
import { breakpoint, sizes } from 'variables';
import Option from './option';

const OptionGrid = styled.div`
    display: grid;
    grid-template-columns: 100%;
    gap: ${Spacing12};
    margin-bottom: ${Spacing24};

    ${breakpoint.up(sizes.md)} {
        grid-template-columns: repeat(3, 1fr);
    }
`;

interface IOptionList {
    donationOptions: DonationOption[];
}

export default function OptionList({ donationOptions }: IOptionList): JSX.Element {
    return (
        <OptionGrid>
            {donationOptions.map(
                (option): JSX.Element => (
                    <Option donationOption={option} key={option.addToBasketLinkAction.url} />
                )
            )}
        </OptionGrid>
    );
}
